module.exports = __webpack_public_path__ + "img/green_114.56b19ab0.png";